// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file audit_logs_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AuditLog, AuditLogJson, AuditLogType, AuditLogTypeJson } from "./audit_logs_pb";
import { file_audit_logs } from "./audit_logs_pb";
import type { DateTimeFilter, DateTimeFilterJson, ListFilter, ListFilterJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file audit_logs_service.proto.
 */
export const file_audit_logs_service: GenFile = /*@__PURE__*/
  fileDesc("ChhhdWRpdF9sb2dzX3NlcnZpY2UucHJvdG8SCXJhY2Nvb25haSLsAQoTQXVkaXRMb2dMaXN0UmVxdWVzdBIoCg9vcmdhbml6YXRpb25faWQYASABKARSD29yZ2FuaXphdGlvbl9pZBI1Cglsb2dfdHlwZXMYAiADKA4yFy5yYWNjb29uYWkuQXVkaXRMb2dUeXBlUglsb2dfdHlwZXMSOwoLdGltZV9maWx0ZXIYAyABKAsyGS5yYWNjb29uYWkuRGF0ZVRpbWVGaWx0ZXJSC3RpbWVfZmlsdGVyEjcKC2xpc3RfZmlsdGVyGAogAigLMhUucmFjY29vbmFpLkxpc3RGaWx0ZXJSC2xpc3RfZmlsdGVyInYKDEF1ZGl0TG9nTGlzdBIzCgphdWRpdF9sb2dzGAEgAygLMhMucmFjY29vbmFpLkF1ZGl0TG9nUgphdWRpdF9sb2dzEjEKCWxpc3RfaW5mbxgCIAEoCzITLnJhY2Nvb25haS5MaXN0SW5mb1IJbGlzdF9pbmZvMl4KEEF1ZGl0TG9nc1NlcnZpY2USSgoNTGlzdEF1ZGl0TG9ncxIeLnJhY2Nvb25haS5BdWRpdExvZ0xpc3RSZXF1ZXN0GhcucmFjY29vbmFpLkF1ZGl0TG9nTGlzdCIAQgZaBC4vcGI", [file_audit_logs, file_general]);

/**
 * @generated from message raccoonai.AuditLogListRequest
 */
export type AuditLogListRequest = Message<"raccoonai.AuditLogListRequest"> & {
  /**
   * @generated from field: optional uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: repeated raccoonai.AuditLogType log_types = 2 [json_name = "log_types"];
   */
  logTypes: AuditLogType[];

  /**
   * @generated from field: optional raccoonai.DateTimeFilter time_filter = 3 [json_name = "time_filter"];
   */
  timeFilter?: DateTimeFilter;

  /**
   * @generated from field: required raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.AuditLogListRequest
 */
export type AuditLogListRequestJson = {
  /**
   * @generated from field: optional uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: repeated raccoonai.AuditLogType log_types = 2 [json_name = "log_types"];
   */
  log_types?: AuditLogTypeJson[];

  /**
   * @generated from field: optional raccoonai.DateTimeFilter time_filter = 3 [json_name = "time_filter"];
   */
  time_filter?: DateTimeFilterJson;

  /**
   * @generated from field: required raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.AuditLogListRequest.
 * Use `create(AuditLogListRequestSchema)` to create a new message.
 */
export const AuditLogListRequestSchema: GenMessage<AuditLogListRequest, {jsonType: AuditLogListRequestJson}> = /*@__PURE__*/
  messageDesc(file_audit_logs_service, 0);

/**
 * @generated from message raccoonai.AuditLogList
 */
export type AuditLogList = Message<"raccoonai.AuditLogList"> & {
  /**
   * @generated from field: repeated raccoonai.AuditLog audit_logs = 1 [json_name = "audit_logs"];
   */
  auditLogs: AuditLog[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.AuditLogList
 */
export type AuditLogListJson = {
  /**
   * @generated from field: repeated raccoonai.AuditLog audit_logs = 1 [json_name = "audit_logs"];
   */
  audit_logs?: AuditLogJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.AuditLogList.
 * Use `create(AuditLogListSchema)` to create a new message.
 */
export const AuditLogListSchema: GenMessage<AuditLogList, {jsonType: AuditLogListJson}> = /*@__PURE__*/
  messageDesc(file_audit_logs_service, 1);

/**
 * @generated from service raccoonai.AuditLogsService
 */
export const AuditLogsService: GenService<{
  /**
   * @generated from rpc raccoonai.AuditLogsService.ListAuditLogs
   */
  listAuditLogs: {
    methodKind: "unary";
    input: typeof AuditLogListRequestSchema;
    output: typeof AuditLogListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_audit_logs_service, 0);

